import { render, staticRenderFns } from "./modulo-eod-detail.vue?vue&type=template&id=1f5816fa&scoped=true"
import script from "./modulo-eod-detail.vue?vue&type=script&lang=js"
export * from "./modulo-eod-detail.vue?vue&type=script&lang=js"
import style0 from "./modulo-eod-detail.vue?vue&type=style&index=0&id=1f5816fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5816fa",
  null
  
)

export default component.exports